(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('ExternalLocationsOverviewController', [
        '$rootScope',
		'SharedAgendaBroadcast',
        'ExternalLocationService',
        'ItemTableService',
        'SharedAgendaService',
        '$uibModal',
        'HelperService',
        ExternalLocationsOverviewControllerFn]);

    /* controlle for email-overview */
    function ExternalLocationsOverviewControllerFn(
        $rootScope,
		SharedAgendaBroadcast,
        ExternalLocationService,
        ItemTableService,
        SharedAgendaService,
        $uibModal,
        HelperService) {
            
        var vm = this;
        
        vm.locations = [];
        vm.agendaId = SharedAgendaService.data.currentAgenda.id;

        activate();

        function activate() {            
            loadExternalLocations();
        }

        function loadExternalLocations() {            
            ExternalLocationService.getAllExternalLocations(vm.agendaId)
                .then(function(locations) {
                    vm.locations = locations;

                    var itemTableService = ItemTableService.Instance();
                    itemTableService.init(vm.locations);
                    vm.overview = itemTableService;
                });
        }

        vm.new = function() {
          var newLocation = {
            id: 0,
            agendaId: vm.agendaId,            
            name: '',
            default: false,
            street: '',
            houseNumber: '',
            zipCode: '',
            city: '',
            country: {
                caption: 'België',
                id: 22
            }            
          };
          showEditModal(newLocation);
        }

        vm.edit = function(location) {
            showEditModal(location);
        }

        vm.delete = function(location) {
            var confirmationModal = HelperService.deactivatingConfirmationModal();
            confirmationModal.result.then(function() {
                return ExternalLocationService.deleteExternalLocation(vm.agendaId, location.id)
                                    .then(function() {
                                       loadExternalLocations();
                                       
                                       // broadcast that the data for the current agenda owner has been updated
						               $rootScope.$broadcast(SharedAgendaBroadcast.AgendaOwnerLoaded);
                                    });
            });
        }

        function showEditModal(location) {           
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/settings/agendasettings/modules/external-locations/detail.html',
                controller: 'ExternalLocationDetailController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    location: ['ExternalLocationService', function (ExternalLocationService) {
                        if (location.id <= 0) {
                            return location;
                        }
                        
                        return ExternalLocationService
                                    .getExternalLocation(vm.agendaId, location.id)
                                    .then(function (location) {
                                        
                            location.country = {
                                id: location.countryId,
                                caption: location.countryCaption
                            };
                            return location;
                        });
                    }],
                    allLocations: function () {
                        return vm.locations;
                    }
                }
            });

            // modal is closed
            modalInstance.result.then(function (item) {
                return loadExternalLocations();
            });
        } 
    }
})();
